module.exports = __webpack_public_path__ + "img/icon_aside_ppt4_hover.3025deeb.svg";